/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SparklingInputs */

const en_val_sparkling = /** @type {(inputs: Val_SparklingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sparkling`)
};

const es_val_sparkling = /** @type {(inputs: Val_SparklingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espumoso`)
};

const fr_val_sparkling = /** @type {(inputs: Val_SparklingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pétillant`)
};

const de_val_sparkling = /** @type {(inputs: Val_SparklingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schaumwein`)
};

const ja_val_sparkling = /** @type {(inputs: Val_SparklingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スパークリング`)
};

const zh_val_sparkling = /** @type {(inputs: Val_SparklingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`起泡酒`)
};

const ar_val_sparkling = /** @type {(inputs: Val_SparklingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نبيذ فوار`)
};

const id_val_sparkling = /** @type {(inputs: Val_SparklingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berkilau`)
};

const it_val_sparkling = /** @type {(inputs: Val_SparklingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spumante`)
};

const ru_val_sparkling = /** @type {(inputs: Val_SparklingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игристое`)
};

const pt_val_sparkling = /** @type {(inputs: Val_SparklingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espumante`)
};

const ko_val_sparkling = /** @type {(inputs: Val_SparklingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스파클링`)
};

/**
* | output |
* | --- |
* | "Sparkling" |
*
* @param {Val_SparklingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_sparkling = /** @type {((inputs?: Val_SparklingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SparklingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_sparkling(inputs)
	if (locale === "es") return es_val_sparkling(inputs)
	if (locale === "fr") return fr_val_sparkling(inputs)
	if (locale === "de") return de_val_sparkling(inputs)
	if (locale === "ja") return ja_val_sparkling(inputs)
	if (locale === "zh") return zh_val_sparkling(inputs)
	if (locale === "ar") return ar_val_sparkling(inputs)
	if (locale === "id") return id_val_sparkling(inputs)
	if (locale === "it") return it_val_sparkling(inputs)
	if (locale === "ru") return ru_val_sparkling(inputs)
	if (locale === "pt") return pt_val_sparkling(inputs)
	return ko_val_sparkling(inputs)
});